// Guard para páginas protegidas. Checa autenticação antes de renderizar;
// se não há usuário logado, redireciona conforme a opção `unauthRedirect`.
//
// Default: `/login.html?redirect=<path-original>` para que após autenticar
// o usuário volte exatamente onde queria ir.
//
// Convenção (Etapa 1 do redesign):
//  - Acesso à raíz `/` (index.html, app autenticado) sem login → landing pública.
//    main.js passa `{ unauthRedirect: '/landing.html' }`.
//  - Demais páginas internas (home, invite) sem login → /login.html?redirect=…
//
// Uso em páginas via Vite (main.js):
//   import { ensureAuthenticated } from './core/authGuard.js';
//   const user = await ensureAuthenticated();
//   const user = await ensureAuthenticated({ unauthRedirect: '/landing.html' });

import { waitForAuth } from './auth.js';
// Side-effect: instala o guard do botão "voltar" → fecha modal. Cobre páginas
// protegidas que não importam logout.js (ex: admin). Idempotente.
import './modalBackGuard.js';

const LOGIN_PATH = '/login.html';

export async function ensureAuthenticated(opts = {}) {
  const user = await waitForAuth();
  if (!user) {
    const target = opts.unauthRedirect ?? buildLoginRedirect();
    location.replace(target);
    // Retorna promessa pendente para travar a execução do chamador até o redirect.
    return new Promise(() => {});
  }
  return user;
}

function buildLoginRedirect() {
  const here = location.pathname + location.search + location.hash;
  const qs = here && here !== '/' ? `?redirect=${encodeURIComponent(here)}` : '';
  return LOGIN_PATH + qs;
}

/**
 * Inverso: usado na própria página de login. Se já estamos autenticados,
 * volta pra onde queríamos ir (ou pra home).
 */
export async function redirectIfAuthenticated(fallback = '/') {
  const user = await waitForAuth();
  if (user) {
    const params = new URLSearchParams(location.search);
    const redirect = params.get('redirect');
    location.replace(safeRedirect(redirect) || fallback);
    return new Promise(() => {});
  }
  return null;
}

// Só aceita redirect relativo dentro do próprio domínio — bloqueia
// ?redirect=https://evil.com/phishing
function safeRedirect(path) {
  if (!path) return null;
  if (!path.startsWith('/')) return null;
  if (path.startsWith('//')) return null;
  return path;
}
